import { DateTime } from 'luxon';
export var handleSubscriptionName = function (name, t) {
    switch (name) {
        case 'trial':
            return t('subscription.alert.trial');
        case 'business':
            return t('subscription.alert.business');
        default:
            return name;
    }
};
export var formatDate = function (date) {
    return DateTime.fromISO(date).toFormat('dd.MM.yyyy');
};
export var handleDifferenceInDays = function (date) {
    var parsedDate = DateTime.fromISO(date);
    var today = DateTime.now();
    return parsedDate.diff(today, 'days').days;
};
export var isValidSubscription = function (expirationDate) {
    return DateTime.fromISO(expirationDate).diff(DateTime.now(), 'days').days > 0;
};
